export default "__VITE_ASSET__DzIfCyeF__"